import Api from '../Base'

class DeleteSpaceInstance extends Api {
  requestUrl = `/api/spaceInstance/${this.getParams().id}`

  method = 'DELETE'
}

export default DeleteSpaceInstance
